export default {
  infoUserContent: {},
  userDataContent:{},
  infoTitle:{},
  divData:{},
  infoDivPhoneCountry: {
    display: 'flex',
    alignItems: 'center',
      '& img': {
        marginRight: '6px'
      }
  },
  infoUserContainer: {
    borderBottom: 'none !important',
    paddingBottom: '0px !important',
    font: '14px "Roboto", sans-serif',
    '@media (max-width: 901px)': {
      padding: '15px !important',
    },
    '& $infoUserContent': {
      marginBottom: '15px',
      '& div':{
        marginBottom: '10px',
        paddingTop: '10px'
      },
      '& span': {
        marginRight: '5px'
      },
      '@media(min-width: 801px)': {
        display: 'flex',
        justifyContent: 'space-between',
        '& div':{
          marginBottom: 'unset',
          paddingTop: 'unset'
        },        
      },      
    },
    '& button':{      
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '& $userDataContent':{
      display: 'grid',
      gap: '5%',
      rowGap: '20px',
      '@media (min-width: 801px) and (max-width: 900px)': {
        gridTemplateColumns: '1fr 1fr',
      },
      '@media (min-width: 1115px)': {
        gridTemplateColumns: '1fr 1fr',
      },
      '& $divData':{
        display: 'flex',
        gridGap: '10px',
        lineBreak: 'anywhere',
        '& $infoTitle':{
          fontWeight: 'bold',
        },
        '&:nth-child(3)':{
          '@media (max-width: 800px)': {
            '& > span':{
              minWidth: '43px',
            }
          }
        },
      },
    },
  },
  editBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
};
